import {
  type Action,
  type ControlType,
  TrackObject,
  useAnalyticsTracker,
} from "./AnalyticsProvider";

type BaseGameplayExtras = {
  id: string;
  gameId?: string;
  gameName?: string;
  imageIndex?: string;
  version?: string;
  controlLabel?: string;
};

type GameplayViewedEvent = {
  action: Action.VIEWED;
  extras: BaseGameplayExtras;
};

type GameplayPressedEvent = {
  action: Action.PRESSED;
  extras: BaseGameplayExtras & {
    control: string;
    controlType: ControlType;
  };
};

type GameplayHoverEvent = {
  action: Action.HOVER;
  extras: BaseGameplayExtras & {
    control: string;
    controlType: ControlType;
  };
};

export type GameplayEvent =
  | GameplayViewedEvent
  | GameplayPressedEvent
  | GameplayHoverEvent;

export const useGameplayAnalytics = () =>
  useAnalyticsTracker<GameplayEvent>(TrackObject.GAMEPLAY);
